<template>
  <div id="content">
    <HeaderLayout></HeaderLayout>
    <div style="height: 120px;"></div>
    <div class="msg_nav">
      <div class="left_text">
        <h1 class="title" style="margin-top: 45px;">{{category}}</h1>
        <p><a class="aHover" @click="showList">{{category}}列表</a> > {{category}}详情</p>
      </div>
      <div class="right_img">
        <img src="../assets/image23.png" alt="" class="inset_img" />
      </div>
    </div>

    <div class="body">
      <h1 class="article_title">{{ title }}</h1>
      <p class="time">{{ time }}</p>
      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>
      <div class="article_content" v-html="formattedContent" v-else></div>
    </div>

    <div style="clear: both"></div>
  </div>
</template>

<script>
import HeaderLayout from '@/layout/HeaderLayout.vue';
import axios from 'axios';

export default {
  name: "MessageDetail",
  components: { HeaderLayout },
  data() {
    return {
      formattedContent: '',
      title: '',
      time: '',
      articleUrl: this.$route.query.url,
      showBody: false,
      loading: false,
      category: this.$route.query.category
    };
  },
  async mounted() {
    await this.fetchArticleContent();
  },
  methods: {
    async fetchArticleContent() {
      this.loading = true;
      if (typeof(this.articleUrl) === "undefined") {
        return;
      }
      const apiUrl = `https://h5.guangzhoutaixie.com/xhapi/api/articles/html?url=${this.articleUrl}`;
      try {
        const response = await axios.get(apiUrl);
        if (response.data.code === 200) {
          let json = response.data.data instanceof Object ? response.data.data : JSON.parse(response.data.data);
          const htmlContent = json.html;
          this.formattedContent = this.processContent(htmlContent);
          this.title = json.title; 
          this.time = json.create_time; 
          this.showBody = true;
        }
      } catch (error) {
        console.error('获取文章内容失败:', error);
      } finally {
        this.loading = false;
      }
    },
    processContent(html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // 移除所有具有特定 data-id 的元素
      ['95447','97306', '97717', '104583'].forEach(id => {
        const elementsToRemove = tempDiv.querySelectorAll(`[data-id="${id}"]`);
        elementsToRemove.forEach(element => element.remove());
      });

      return tempDiv.innerHTML; // 返回处理后的 HTML
    },
    showList(){
      let idx = this.$route.query.idx;
      this.$router.push({ name: 'home', query: { idx:idx } });
    }
  },
};
</script>

<style scoped>
@import "../style/common.css";
@import "../style/message-detail.css";
@import "../style/loading.css";
#content{
  background: linear-gradient(180deg, #E7F8FF 0%, rgba(246, 246, 255, 0) 100%);
}
</style>